import React, { Component } from "react"
import {
  removeStorage,
} from "../components/CustomComponent.js"
import "../assets/css/bootstrap.css"

export default class Loading extends Component {
  componentDidMount() {
   window.location.href = "/home";
  }
  render() {
    return <div></div>
  }
}
